import {
  IndeedCandidateConversation,
  IndeedCandidateMessagesEdgeAttribute,
  TimelineModuleResultData,
} from './indeed.types';

export function normalizeString(input: string): string {
  if (!input) return '';

  return input
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, ' ');
}

export const filterConversationsByCandidateName = (
  last50Conversations: IndeedCandidateConversation[],
  candidateName: string,
) => {
  const normalizedCandidateName = normalizeString(candidateName);

  return last50Conversations.filter((conversation) => {
    return conversation.participants.some((participant) => {
      const normalizedParticipantName = normalizeString(participant.participantName);
      return normalizedParticipantName === normalizedCandidateName;
    });
  });
};

export const getConversationsBasedOnResponse = (response: any) => {
  try {
    return response.data.findConversations.conversations;
  } catch (err) {
    console.error(err);
    return [];
  }
};

export const extractJobInfo = (edge: IndeedCandidateMessagesEdgeAttribute) => {
  try {
    const jobInfo: TimelineModuleResultData = JSON.parse(edge.node.timelineModuleResult?.data ?? '');
    if (Object.keys(jobInfo).length === 0 || jobInfo?.jobTitle == null) return undefined;
    return jobInfo;
  } catch (error) {
    return undefined;
  }
};
